import React from 'react';
import { Drawer, List, Link, Stack, Typography, ListItem } from '@mui/material'
import {ExitToApp, MailOutlineOutlined, PersonOutline }  from '@mui/icons-material';
import useAuth from '../../hooks/useAuth';
import { APP_VERSION } from '../../config';

export default function DrawerCustom(props) {
  const { user } = useAuth();
  const nome = user.nome && user.nome.split(' ')[0];
  const itens = [
    // { nome: 'Perfil', icon: <PersonOutline />, route: "/" },
    { nome: 'Entre em Contato', icon: <MailOutlineOutlined />, route: `https://wa.me/5551991629970?text=Olá, sou ${nome}, CPF: ${user.cpf_cnpj}.` },
    { nome: 'Encerrar Sessão', icon: <ExitToApp />, route: "/" },
  ];

  const handleClick = (linha) => {
    props.onClose(linha.route)
  }

  return <Drawer anchor='left' variant='temporary' open={props.open} onClose={() => props.onClose('')} PaperProps={{ style: { backgroundColor: 'white' } }}>
    <div><img width='100%' style={{ padding: '32px 32px' }} src={process.env.PUBLIC_URL + "/static/logo.png"} alt="AgyxLogo"></img></div>
    <List>
      {itens.map((item, index) => <ListItem 
        key={index} 
        button 
        component={Link} 
        underline="none" 
        sx={{ color: 'grey.700' }} 
        target={item.nome === 'Entre em Contato' ? '_blank' : null} 
        href={item.nome === 'Entre em Contato' ? encodeURI(item.route) : null} 
        onClick={item.nome === 'Entre em Contato' ? null : () => handleClick(item)} 
      >
        <Stack direction='row' spacing={1} alignItems='center' >
          {item.icon}
          <Typography variant='body1'>
            {item.nome}
          </Typography>
        </Stack>
      </ListItem>)}
      <ListItem><Typography variant='caption'>{APP_VERSION}</Typography></ListItem>
    </List>
  </Drawer>
}
